(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderInlineMenuScroll {
    constructor(menu) {
      this.menu = menu;
      this.track = menu.querySelector('[data-header-menu-track]');
      this.prevButton = menu.querySelector('[data-header-menu-scroll="prev"]');
      this.nextButton = menu.querySelector('[data-header-menu-scroll="next"]');
      this.list = this.track && this.track.querySelector('.list-menu--inline');
      if (!this.track || !this.prevButton || !this.nextButton || !this.list) return;

      this.onButtonClick = this.onButtonClick.bind(this);
      this.update = this.update.bind(this);

      this.prevButton.addEventListener('click', this.onButtonClick);
      this.nextButton.addEventListener('click', this.onButtonClick);
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.resizeObserver.observe(this.list);
      }

      requestAnimationFrame(this.update);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.update);
      }
    }

    onButtonClick(event) {
      const direction = event.currentTarget.dataset.headerMenuScroll === 'prev' ? -1 : 1;
      this.track.scrollBy({
        left: direction * Math.max(120, this.track.clientWidth * 0.65),
        behavior: 'smooth',
      });
    }

    update() {
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 1;
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      this.menu.classList.toggle('has-overflow', hasOverflow);
      this.prevButton.hidden = !hasOverflow || atStart;
      this.nextButton.hidden = !hasOverflow || atEnd;
    }
  }

  document.querySelectorAll('[data-header-inline-menu]').forEach((menu) => {
    new HeaderInlineMenuScroll(menu);
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this._onHeaderHeightChange = this.setHeaderHeight.bind(this);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this._onHeaderHeightChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      const HEADER_HEIGHT_PX = 75;
      const inner = this.querySelector('.header');
      const wrapper = this.querySelector('.header-wrapper');
      const transparent = document.documentElement.classList.contains('transparent-header-active');
      document.documentElement.style.setProperty('--header-height', HEADER_HEIGHT_PX + 'px');
      this.syncHeaderBottomPosition();
      if (transparent && inner) {
        const measuredHeight = Math.ceil((wrapper || inner).getBoundingClientRect().height || HEADER_HEIGHT_PX);
        const transparentHeight = Math.max(HEADER_HEIGHT_PX, measuredHeight);
        document.documentElement.style.setProperty('--transparent-header-height', transparentHeight + 'px');
        this.header.style.minHeight = transparentHeight + 'px';
        return;
      }
      this.header.style.minHeight = '';
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this._onHeaderHeightChange) {
        window.matchMedia('(max-width: 990px)').removeEventListener('change', this._onHeaderHeightChange);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        if (entries[0]) this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop !== this.currentScrollTop) {
        this.closeMenuDisclosure(true);
        this.closeSearchModal();
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) {
          this.header.classList.add('scrolled-past-header');
          return;
        }
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('scrolled-past-header');
        } else {
          /* One DOM update: avoids a paint of full docked bar before hidden (transparent header flash) */
          this.header.classList.add(
            'scrolled-past-header',
            'shopify-section-header-sticky',
            'animate',
            'shopify-section-header-hidden'
          );
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      if (document.documentElement.classList.contains('transparent-header-active')) {
        requestAnimationFrame(() => this.setHeaderHeight());
      }

      requestAnimationFrame(() => this.syncHeaderBottomPosition());
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      /* One sync update: sticky + animate + hidden avoids intermediate frames (double rAF caused a visible flash) */
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'shopify-section-header-hidden');
      this.closeMenuDisclosure(true);
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      requestAnimationFrame(() => {
        this.header.classList.remove('shopify-section-header-hidden');
        this.syncHeaderBottomPosition();
      });
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.syncHeaderBottomPosition();
    }

    syncHeaderBottomPosition() {
      if (!this.header) return;
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }

    closeMenuDisclosure(force = false) {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close(force));
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
